import { Link } from 'react-router-dom';

import {
  DEMO_REACH,
  SCORE_CTA_PRIMARY_BUTTON_CLASS,
  ScoreCtaInner,
} from './project/ScoreCtaBox';
import { trackButtonClick } from '../services/telemetry';

export type FreePlanReminderMode = 'upsell' | 'purchased';

/**
 * Inner copy on a score generated without a credit
 * (`creditConsumed === 0`). The project pages wrap this in
 * `ScoreCtaBox` and pass it as `ScoreViewport`'s `footer`.
 *
 * `upsell` describes this score and points free users at /pricing.
 * `purchased` thanks a caller who already has a spendable credit and
 * points them at /workspace (“My Project”) to re-upload the original file.
 */
export const FreePlanReminderBar = ({
  variant,
  mode = 'upsell',
}: {
  variant: 'xml' | 'pdf';
  mode?: FreePlanReminderMode;
}) => {
  const isPurchased = mode === 'purchased';

  return (
    <div
      role="region"
      aria-label={isPurchased ? 'My Project reminder' : 'Free plan reminder'}
    >
      <ScoreCtaInner
        title={
          isPurchased
            ? 'Thank you for your purchase!'
            : `This is a free preview project (${DEMO_REACH[variant]}).`
        }
        subtitle={
          isPurchased
            ? 'This project was generated as a preview. Please re-upload your original score at “My Project” page to get full access.'
            : 'Upgrade to unlock for full scores'
        }
      >
        <Link
          to={isPurchased ? '/workspace' : '/pricing'}
          onClick={async () =>
            // Names stay stable: trackButtonClick records Application
            // Insights as `Button - ${pageName} - ${buttonText}`.
            await trackButtonClick(
              'SubscriptionStatusMsgFingering',
              isPurchased ? 'Re-upload Original' : 'Subscribe'
            )
          }
          className={SCORE_CTA_PRIMARY_BUTTON_CLASS}
        >
          {isPurchased ? 'My Project' : 'Upgrade'}
        </Link>
      </ScoreCtaInner>
    </div>
  );
};
